import { render, staticRenderFns } from "./importResourceStore.vue?vue&type=template&id=08de4950&scoped=true"
import script from "./importResourceStore.vue?vue&type=script&lang=js"
export * from "./importResourceStore.vue?vue&type=script&lang=js"
import style0 from "./importResourceStore.vue?vue&type=style&index=0&id=08de4950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de4950",
  null
  
)

export default component.exports